import React, { FC, memo } from 'react';
import { Props } from './types';

import { Container, AddImage, ImageContainer } from './styles';

const ItemListImage: FC<Props> = ({ src, alt }) => {
  return (
    <Container>
      {src == null ? (
        <ImageContainer>
          <AddImage />
        </ImageContainer>
      ) : null}
      {src != null ? (
        <img src={src} alt={alt} width="48px" height="48px" />
      ) : null}
    </Container>
  );
};

export default memo(ItemListImage);
